import { render, staticRenderFns } from "./SandBox_shenzhen.vue?vue&type=template&id=6243bf3c&scoped=true"
import script from "./SandBox_shenzhen.vue?vue&type=script&lang=js"
export * from "./SandBox_shenzhen.vue?vue&type=script&lang=js"
import style0 from "./SandBox_shenzhen.vue?vue&type=style&index=0&id=6243bf3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6243bf3c",
  null
  
)

export default component.exports